import chipStatusColor from './chipStatusColor'
import chipStatusLabel from './chipStatusLabel'
import getStepApi from './getStepApi'
import mountConfirmationPay from './mountConfirmationPay'
import saveText from './saveText'
import calcDate from './calcDate'
import mount from './mount'
import textSendEmail from './textSendEmail'

const paymentOrders = {
  chipStatusColor,
  chipStatusLabel,
  getStepApi,
  mountConfirmationPay,
  saveText,
  calcDate,
  mount,
  textSendEmail,
}

export default paymentOrders
